import { getAllQueryKeys, invalidateReactQueryCache, updateReactQueryCache } from 'contexts/QueryClientProvider';
import { QueryKey } from 'react-query';
import { GuestAppointmentResponse } from './types';
import { GUEST_APPOINTMENT_KEY } from './constants';

const QUERY_KEY = 'useGuestAppointmentQueryKey';

interface GetQueryKeyParams {
  disabled?: boolean;
  patientId?: number | null;
  includeDeleted?: boolean;
}

export const getGuestAppointmentIdFromSession = (): string | null => {
  const guestAppointmentId: string | null = sessionStorage.getItem(GUEST_APPOINTMENT_KEY);
  return ['undefined', 'null'].includes(guestAppointmentId as string) ? null : guestAppointmentId;
};

export const getQueryKey = ({ patientId, disabled = false, includeDeleted = false }: GetQueryKeyParams) => {
  const guestAppointmentId = getGuestAppointmentIdFromSession();
  return [QUERY_KEY, disabled, patientId, guestAppointmentId, includeDeleted];
};

export const updateQueryData = (queryKey: QueryKey, data: GuestAppointmentResponse) => {
  const keys = getAllQueryKeys().filter(key => Array.isArray(key) && key[0] === QUERY_KEY);
  const queryKeyString = JSON.stringify(queryKey);
  keys.forEach(key => {
    if (JSON.stringify(key) === queryKeyString) {
      updateReactQueryCache(queryKey, data);
    } else {
      invalidateReactQueryCache(key);
    }
  });
};
